import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid} from '../question-helper';
import {QuestionType} from '../../constants';
import {Profession} from '../../models/Profession';
import {Industry} from '../../models/Industry';

declare const $: any;
declare const easyAutocomplete: any;

@Component({
    selector: 'app-question-autocomplete',
    templateUrl: './question-autocomplete.component.html',
    styleUrls: ['./question-autocomplete.component.scss'],
    standalone: false
})
export class QuestionAutocompleteComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Input() items: any[];
  @Input() placeHolder = 'Profession';
  @Input() inputType = 'text';
  @Input() value: any;
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlId = `textbox-autocomplete-${newGuid()}`;
  uniqueControlName = `textbox-autocomplete-${newGuid()}`;

  QuestionTypes = QuestionType;
  professions: Profession[] = [];
  industries: Industry[] = [];

  constructor(private globalQuestionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    //this.startSpinner(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      if (this.question) {
        if (this.question?.question_prompt) {
          this.placeHolder = this.question?.question_prompt;
        }
        this.value = this.question?.answer;
        //this.startSpinner(true);
        this.getData();
      }
    }
  }

  getData(): void {
    if (this.question?.cent_aq_question_type_id === QuestionType.profession) {
      this.value = this.question?.answer;
      this.globalQuestionService.getProfessions()
        .subscribe(x => {
          this.professions = x;
          this.initAutoComplete(this.professions, QuestionType.profession);
          this.startSpinner(false);
        });
    } else if (this.question?.cent_aq_question_type_id === QuestionType.industry) {
      this.globalQuestionService.getIndustries()
        .subscribe(x => {
          this.industries = x;
          this.initAutoComplete(this.industries, QuestionType.industry);
          this.startSpinner(false);
        });
    }
  }

  onChange(type: QuestionType): void {
    if (this.question) {
      if (this.value) {
        this.question.answer = this.value;
        this.questionAnswer.emit(this.question);
      } else {
        this.question.answer = '';
        this.questionAnswer.emit(this.question);
      }
    }
  }

  startSpinner(start: boolean): void {
    if (start) {
      //this.globalQuestionService.spinner(true);
    } else {
      this.globalQuestionService.spinner(false);
    }
  }

  initAutoComplete(items: any[], type: QuestionType): void {
    setTimeout(() => {
      $(`#${this.uniqueControlId}`).easyAutocomplete({
        data: items,
        getValue: x => {
          if (type === QuestionType.profession) {
            return x.profession_sub;
          } else if (type === QuestionType.industry) {
            return x.industry;
          }
        },
        list: {
          match: {
            enabled: true
          },
          sort: {
            enabled: true // alphabetical order
          },
          onChooseEvent: () => {
            const selected = $(`#${this.uniqueControlId}`).getSelectedItemData();
            if (type === QuestionType.profession) {
              this.value = selected?.profession_sub;
            } else if (type === QuestionType.industry) {
              this.value = selected?.industry;
            }
            this.onChange(type);
          },
        }
      });
    }, 2000);
  }
}
